/**
 * @generated SignedSource<<79cd8a0e8638b30ae57a666d5d187f7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExplicitOwners_removeEventOwner_Mutation$variables = {
  memberId: string;
  nodeId: string;
};
export type ExplicitOwners_removeEventOwner_Mutation$data = {
  readonly removeEventOwner: {
    readonly eventUpdated: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ExplicitOwners_ownership">;
    };
    readonly removedOwnerMemberId: string;
  } | null;
};
export type ExplicitOwners_removeEventOwner_Mutation = {
  response: ExplicitOwners_removeEventOwner_Mutation$data;
  variables: ExplicitOwners_removeEventOwner_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "eventId",
        "variableName": "nodeId"
      },
      {
        "kind": "Variable",
        "name": "memberId",
        "variableName": "memberId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removedOwnerMemberId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExplicitOwners_removeEventOwner_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CalendarEventsRemoveOwnerMutationPayload",
        "kind": "LinkedField",
        "name": "removeEventOwner",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "eventUpdated",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ExplicitOwners_ownership"
                  }
                ],
                "type": "HasOwnerPermissionsInterface",
                "abstractKey": "__isHasOwnerPermissionsInterface"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ExplicitOwners_removeEventOwner_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CalendarEventsRemoveOwnerMutationPayload",
        "kind": "LinkedField",
        "name": "removeEventOwner",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "eventUpdated",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OwnershipConnection",
                    "kind": "LinkedField",
                    "name": "ownerships",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OwnershipEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Ownership",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Member",
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "email",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MemberAvatar",
                                    "kind": "LinkedField",
                                    "name": "avatar",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "url",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "roles",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "value",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OwnableConnection",
                                "kind": "LinkedField",
                                "name": "ownerOf",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OwnableEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v7/*: any*/),
                                            "type": "Space",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v7/*: any*/),
                                            "type": "Event",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v7/*: any*/),
                                            "type": "Folder",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v4/*: any*/)
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "explicitOwner",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "HasOwnerPermissionsInterface",
                "abstractKey": "__isHasOwnerPermissionsInterface"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a2dcb71254c150846b45ad35c4118003",
    "id": null,
    "metadata": {},
    "name": "ExplicitOwners_removeEventOwner_Mutation",
    "operationKind": "mutation",
    "text": "mutation ExplicitOwners_removeEventOwner_Mutation(\n  $nodeId: ID!\n  $memberId: ID!\n) {\n  removeEventOwner(input: {eventId: $nodeId, memberId: $memberId}) {\n    removedOwnerMemberId\n    eventUpdated {\n      id\n      ... on HasOwnerPermissionsInterface {\n        __isHasOwnerPermissionsInterface: __typename\n        ...ExplicitOwners_ownership\n      }\n    }\n  }\n}\n\nfragment ExplicitOwners_ownership on HasOwnerPermissionsInterface {\n  __isHasOwnerPermissionsInterface: __typename\n  ownerships {\n    edges {\n      node {\n        ...Owner_ownership\n        explicitOwner\n        member {\n          id\n          status {\n            __typename\n            value\n          }\n        }\n        ownerOf {\n          edges {\n            node {\n              __typename\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment Owner_ownership on Ownership {\n  member {\n    id\n    name\n    ...UserHandle_member\n  }\n  ownerOf {\n    edges {\n      node {\n        __typename\n        ... on Space {\n          name\n        }\n        ... on Event {\n          name\n        }\n        ... on Folder {\n          name\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n"
  }
};
})();

(node as any).hash = "a1cd00312a3d417cdf2f64429a301730";

export default node;
